import Slider from "react-slick";
import logo from './../../../../assets/img/logo.png';
import vid2 from './../../../../assets/vid/2.mp4';

const WelcomeArea2 = (props) => {
  return (
    <>
    <section className="welcome_area2 overflow-hidden" id="home">
        <div className="single-hero-slide2 d-flex justify-content-center">
            <div className="hero-slide-content text-center">
                <h2><b>{props.pg}</b></h2>
            </div>
        </div>
    </section> 
    </>
  )
}
export default WelcomeArea2;